import { z } from 'zod';
/**
 * O corretor de texto do atendente.
 *
 * Propõe, nunca conserta sozinho. Um corretor que reescreve no automático troca o erro de
 * quem escreveu pelo erro de quem corrige — e o que sai dali vai para o cliente assinado
 * pela empresa.
 *
 * Mora num LanguageTool em container na própria VPS (decisão de 08/10): pega concordância
 * ("o cabos" → "os cabos") e não só acento, responde em dezenas de milissegundos, não custa
 * por mensagem e **o texto do cliente não sai da empresa** — que é o que importa para a
 * LGPD.
 */
/** Quanto texto o corretor aceita de uma vez. Acima disso, a mensagem é outra coisa. */
export const TAMANHO_MAXIMO_REVISAO = 4000;
export const revisarSchema = z.object({
    texto: z.string().max(TAMANHO_MAXIMO_REVISAO),
});
/**
 * Palavras da casa que o corretor não deve marcar.
 *
 * Sem esta lista, o atendente vê sublinhado em metade do que escreve — "ONU", "CTO",
 * "PPPoE", "drop" — e desliga o corretor na primeira semana. É por isso que ela nasce
 * junto, e não como refinamento depois.
 *
 * É só o ponto de partida: a lista de verdade fica em `configuracao`, na chave
 * `revisao_jargao`, e cresce sem precisar de deploy.
 */
export const JARGAO_PADRAO = [
    // Rede e equipamento
    'onu',
    'olt',
    'cto',
    'ceo',
    'pppoe',
    'pon',
    'gpon',
    'drop',
    'splitter',
    'patch',
    'rack',
    'switch',
    'roteador',
    'modem',
    'wifi',
    'wi-fi',
    'ssid',
    'ip',
    'dns',
    'dhcp',
    'nat',
    'cgnat',
    'mac',
    'lan',
    'wan',
    'vlan',
    'uplink',
    'downlink',
    'ping',
    'traceroute',
    'firmware',
    'reset',
    'reboot',
    'sinal',
    'dbm',
    'fibra',
    'fibras',
    'conector',
    'mufla',
    'poste',
    'posteação',
    // Operação e sistemas
    'hubsoft',
    'mymaxx',
    'maxx',
    'protocolo',
    'os',
    'rota',
    'rotas',
    'liberação',
    'viabilidade',
    'instalação',
    'reparo',
    'chamado',
    'boleto',
    'pix',
    'mikrotik',
    'ubiquiti',
    'huawei',
    'zte',
    'nokia',
];
//# sourceMappingURL=revisao.js.map